import { Body, H5, Stack } from '@qred/components-library';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  ContactEmails,
  ContactNumbers,
  ContactNumbersFormatted,
} from '~/constants/markets';
import useHubspotChat from '~/hooks/useHubspotChat';
import { isInIframe } from '~/iframeMode';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';
import HelpItem from './HelpItem';
import {
  Bottom,
  BottomInner,
  HackyOverlay,
  HelpItemsContainer,
  Top,
  TopInner,
  TopInnerContent,
} from './HelpSection.styled';

const HelpSection = () => {
  const translate = useTranslate();

  const { openChat } = useHubspotChat();

  const { market } = useSelector((state: RootState) => state.intl);

  return (
    <>
      <Top>
        <TopInner>
          <TopInnerContent>
            <Stack spacing={'sm'}>
              <H5>{translate('Onboarding.ContactUs')}</H5>
              <Body size="lg">{translate('Onboarding.ContactUsText')}</Body>
            </Stack>
          </TopInnerContent>
        </TopInner>
      </Top>
      <Bottom>
        <HackyOverlay />
        <BottomInner>
          <HelpItemsContainer>
            <HelpItem
              element="a"
              href={`tel:${ContactNumbers[market]}`}
              icon="Phone"
              text={ContactNumbersFormatted[market]}
            />
            <HelpItem
              element="a"
              href={`mailto:${ContactEmails[market]}`}
              icon="Mail"
              text={ContactEmails[market]}
            />
            {!isInIframe && (
              <HelpItem
                onClick={openChat}
                icon="Comments"
                text={translate('ContactChat') as string}
              />
            )}
          </HelpItemsContainer>
        </BottomInner>
      </Bottom>
    </>
  );
};

export default HelpSection;
